// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {successAlert, errorAlert} from '@alert'

// ** Axios Imports
import axios from 'axios'


export const getAllData = createAsyncThunk('partners/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('partners/getData', async params => {
  const response = await axios.get(process.env.REACT_APP_BASE_URL + '/api/dashboard/partner?with_paginate=yes', {params})
  return {
    params,
    data: response.data.data.data,
    totalPages: response.data.total,
    loading: true
  }
})

/*export const createUser = createAsyncThunk('partners/createUser', async (user, { dispatch, getState }) => {
  await axios.post(process.env.REACT_APP_BASE_URL + '/api/dashboard/partner' ,user).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().partners.params))
  
  return user
})*/

export const getUser = createAsyncThunk('partners/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.data
})

export const addUser = createAsyncThunk('partners/addUser', async (user, { dispatch, getState }) => {
  await axios.post(process.env.REACT_APP_BASE_URL + '/api/dashboard/partner' ,user).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().partners.params))
  
  return user
})

export const deleteUser = createAsyncThunk('partners/deleteUser', async (slug, { dispatch, getState }) => {
  await axios.delete(process.env.REACT_APP_BASE_URL + `/api/dashboard/partner/${slug}`).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().partners.params))
  await dispatch(getAllData())
  return slug
})
export const updateUser = createAsyncThunk('partners/updateUser', async (params, { dispatch, getState }) => {
  await axios.post(process.env.REACT_APP_BASE_URL + `/api/dashboard/partner/${params.slug}`, params.user).then(res => {
    successAlert()
  }).catch(err => {
    errorAlert()
  })
  await dispatch(getData(getState().partners.params))
   await dispatch(getAllData())
  return params.user
})

export const partnersSlice = createSlice({
  name: 'partners',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages,
        state.loading = action.payload.loading
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload,
        state.loading = action.payload.loading
      })
  }
})

export default partnersSlice.reducer
